import React, {useState} from 'react'
import HeaderStarpath from "../../components/header/HeaderStarpath";
import FooterStarpath from "../../components/footer/FooterStarpath";
import {Unity, useUnityContext} from "react-unity-webgl";

const WEBGL_BASE = process.env.REACT_APP_WEBGL_BASE_URL || '/webgl';

const StarpathGalaxymap = () => {
    const {unityProvider} = useUnityContext({
        loaderUrl: `${WEBGL_BASE}/Starmap/Dist.loader.js`,
        dataUrl: `${WEBGL_BASE}/Starmap/Dist.data.gz`,
        frameworkUrl: `${WEBGL_BASE}/Starmap/Dist.framework.js.gz`,
        codeUrl: `${WEBGL_BASE}/Starmap/Dist.wasm.gz`,
    });
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });


    return (
        <>
            <HeaderStarpath/>
                <Unity unityProvider={unityProvider} style={{
                    width: windowSize.width-25,
                    height: windowSize.height-200,
                    marginTop: "-15px",
                    marginBottom: "-15px",
                }} />
            <FooterStarpath/>
        </>
    )
}

export default StarpathGalaxymap